import { render, staticRenderFns } from "./TicketDetailsModal.vue?vue&type=template&id=5b1e6660&scoped=true"
import script from "./TicketDetailsModal.vue?vue&type=script&lang=js"
export * from "./TicketDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./TicketDetailsModal.vue?vue&type=style&index=0&id=5b1e6660&prod&scoped=true&lang=css"
import style1 from "./TicketDetailsModal.vue?vue&type=style&index=1&id=5b1e6660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1e6660",
  null
  
)

export default component.exports